import { t } from '@app/i18n';
import { SearchCombobox } from '@zarya/ui';
import { useCurrentUser } from '@app/auth/useCurrentUser';
import { ownerOptions, type ApplicationUser } from './owner';

/**
 * O combobox de **Dono**, um só para T5 (identidade) e T7 (resource).
 *
 * Não é `creatable`: dono é uma pessoa cadastrada, não texto livre. Quem está
 * logado vem em primeiro, com «(você)» — a ordenação mora em `opcoesDeDono`,
 * porque o teste dela não precisa de DOM.
 */

export interface OwnerComboboxProps {
  /** Usuários da aplicação (`listUsers`); vazio quando quem olha não pode listá-los. */
  users: ApplicationUser[];
  /** O `Nome <e-mail>` gravado. String vazia = sem dono. */
  value: string;
  onChange: (valor: string) => void;
  id?: string;
  label?: string;
  'aria-describedby'?: string;
  'aria-invalid'?: true;
  disabled?: boolean;
  placeholder?: string;
  emptyMessage?: string;
}

export function OwnerCombobox({
  users,
  value,
  onChange,
  id,
  label = t('common.owner.label'),
  disabled,
  placeholder = t('common.owner.placeholder'),
  emptyMessage = t('common.owner.empty'),
  ...aria
}: OwnerComboboxProps) {
  // A sessão já está carregada em todo o console; `usuario` é nulo enquanto o
  // `getMe` não voltou, e aí simplesmente não há «(você)» para oferecer.
  const { usuario } = useCurrentUser();

  return (
    <SearchCombobox
      id={id}
      aria-describedby={aria['aria-describedby']}
      aria-invalid={aria['aria-invalid']}
      label={label}
      options={ownerOptions({ users, eu: usuario, atual: value })}
      value={value || null}
      onChange={(valor) => onChange(valor ?? '')}
      placeholder={placeholder}
      searchPlaceholder={t('common.owner.search')}
      emptyMessage={emptyMessage}
      disabled={disabled}
    />
  );
}
